module.exports = __webpack_public_path__ + "static/img/ioss.bf8e5d20.png";